<template>
  <a-layout class="dict-content">
    <a-layout-sider :width="layoutWidth" class="leftLayout" id="leftLayout">
      <div class="treeDiv">
        <department-tree-list
          ref="departmentTreeList"
          @reGetData="reGetData"
          @closeMenu="closeMenu"
          @handleImport="handleImport"
          @derive="derive"
        ></department-tree-list>
      </div>
      <a-divider />
      <div class="treeDiv">
        <asset-type-list
          ref="assetTypeList"
          @reGetData="reGetData"
          @closeMenu="closeMenu"
          @handleImport="handleImport"
          @derive="derive"
        ></asset-type-list>
      </div>
      <div class="retraction" v-if="showLeftBtn" @click="closeLeft">
        <div class="retractionBtn"></div>
      </div>
    </a-layout-sider>
    <a-layout-content class="rightLayout">
      <div class="retractionRight" v-if="showRightBtn" @click="openLeft">
        <div class="retractionBtn"></div>
      </div>
      <div class="content">
        <table-data ref="tableDom" @closeMenu="closeMenu"></table-data>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import tableData from '@/views/equipmentLedger/modules/tableData'
import departmentTreeList from '@/views/equipmentLedger/modules/departmentTreeList'
import assetTypeList from '@/views/equipmentLedger/modules/assetTypeList'

export default {
  components: {
    departmentTreeList,
    assetTypeList,
    tableData
  },
  data () {
    return {
      layoutWidth: '240',
      showLeftBtn: true,
      showRightBtn: false,
      // 传给表格的查询条件
      searchTableModel: {},
      // 使用部门点击后储存的参数
      DeptData: {},
      // 资产类型点击后储存的参数
      AssetTypeData: {}
    }
  },
  watch: {
    layoutWidth (newValue, oldValue) {
      if (Number(newValue) > 0) {
        this.showRightBtn = false
        this.showLeftBtn = true
      } else {
        this.showRightBtn = true
        this.showLeftBtn = false
      }
    }
  },
  methods: {
    handleSubmit () {
      // 表单提交成功后,重新获取树的数据
      // this.$refs['treeListDom'].queryDictData(true)
    },
    // 获取右侧表格数据
    reGetData () {
      console.log('重新获取数据')
    },
    closeMenu (type) {
      if (type === 'leftTop') {
        this.$refs.assetTypeList.closeMenu()
        this.$refs.tableDom.closeMenu()
      } else if (type === 'leftBottom') {
        this.$refs.departmentTreeList.closeMenu()
        this.$refs.tableDom.closeMenu()
      } else {
        this.$refs.departmentTreeList.closeMenu()
        this.$refs.assetTypeList.closeMenu()
      }
    },
    handleImport () {
      this.$refs.tableDom.handleImport()
    },
    derive () {
      this.$refs.tableDom.derive()
    },
    // 获取使用部门数据
    // searchDepartmentList (info) {
    //   this.AssetTypeData = info
    //   this.searchTableModel = { ...this.searchTableModel, ...info }
    //   this.$refs.departmentTreeList.getDeptData(info)
    //   this.$refs.tableDom.changTreeSearchTableData(this.searchTableModel)
    // },
    // 获取资产类型数据
    // searchAssetTypeList (info) {
    //   let data = {}
    //   if (info.selectedNodes.length > 0) {
    //     data = {
    //       bukrs: info.selectedNodes[0].data.props.subcompanycode
    //     }
    //     this.DeptData = data
    //   } else {
    //     this.DeptData = {}
    //   }
    //   this.searchTableModel = { ...this.AssetTypeData, ...data }
    //   // this.$refs.assetTypeList.getAssetType(data)
    //   this.$refs.tableDom.changTreeSearchTableData(this.searchTableModel)
    // },
    // 收起左侧树
    closeLeft () {
      this.layoutWidth = '0'
      const dom = document.getElementById('leftLayout')
      dom.style.padding = '0px'
    },
    openLeft () {
      this.layoutWidth = '240'
      const dom = document.getElementById('leftLayout')
      dom.style.padding = '16px'
    }
  }
}
</script>
<style lang="less" scoped>
.dict-content {
  //height: 100%;
  overflow-y: hidden;
}
#leftLayout {
  background: #fff;
  padding:16px;
  margin-right:1px
}
.rightLayout {
  position: relative;
  padding: 10px 12px;
  background: #fff;
  .content {
    height: 100%;
  }
}
.treeDiv {
  height: calc(50% - 10px);
  overflow-y: hidden;
}
.ant-divider-horizontal {
  margin: 10px 0;
}
.retraction {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 14px;
  height: 100px;
  background: #f0f2f5;
  background: linear-gradient(135deg, transparent 10px, #f0f2f5 0) top left,
  linear-gradient(45deg, transparent 10px, #f0f2f5 0) bottom left;
  background-size: 100% 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  .retractionBtn {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 10px;
    height: 14px;
    background: #08409F;
    background: linear-gradient(135deg, transparent 7px, #08409F 0) top left,
    linear-gradient(45deg, transparent 7px, #08409F 0) bottom left;
    background-size: 100% 50%;
    background-repeat: no-repeat;
  }
}
.retractionRight {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 14px;
  height: 100px;
  background: #f0f2f5;
  background: linear-gradient(225deg, transparent 10px, #f0f2f5 0) top left,
  linear-gradient(310deg, transparent 10px, #f0f2f5 0) bottom left;
  background-size: 100% 50%;
  background-repeat: no-repeat;
  cursor: pointer;
  .retractionBtn {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    width: 10px;
    height: 14px;
    background: #08409F;
    background: linear-gradient(225deg, transparent 7px, #08409F 0) top left,
    linear-gradient(315deg, transparent 7px, #08409F 0) bottom left;
    background-size: 100% 50%;
    background-repeat: no-repeat;
  }
}
// 线颜色修改
/deep/.ant-table-bordered .ant-table-header > table{
  //border-color: rgba(185, 222, 255, 1) !im;
}
/deep/.ant-table-bordered .ant-table-thead > tr > th{
  border-right: 0.8px solid rgba(185, 222, 255, 1);
  border-bottom: 0.8px solid rgba(185, 222, 255, 1);
  background-color: #fff !important;
}
/deep/.ant-table-bordered .ant-table-body > table{
  //border-top: 0.8px solid rgba(185, 222, 255, 1);
  //border-left: 0.8px solid rgba(185, 222, 255, 1);
}
/deep/.ant-table-bordered .ant-table-tbody > tr > td{
  border-right: 0.8px solid rgba(185, 222, 255, 1);
  border-bottom: 0.8px solid rgba(185, 222, 255, 1);
}
/deep/.ant-table-tbody > tr > td{
  //border-bottom: 0.8px solid rgba(185, 222, 255, 1);
}
/deep/.ant-table-tbody > tr.ant-table-row-selected td{
  background-color: rgba(225, 225, 225, 0);
}
/deep/.ant-table-bordered.ant-table-fixed-header .ant-table-header > table{
  border-top: 0.8px solid rgba(185, 222, 255, 1);
  //border-bottom: 1.6px solid rgba(185, 222, 255, 1);
}
/deep/.ant-table.ant-table-bordered .ant-table-footer{
  border: none !important;
}
/*有固定行的ant-design-vue 表格滑动样式*/
/deep/.ant-table-fixed .ant-table-row-hover {
  background: rgb(245, 247, 250) !important;
}
/deep/.ant-table-fixed .ant-table-row-hover > td {
  background: rgb(245, 247, 250) !important;
}
/*没有固定行的表格个样式*/
/deep/.ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
  background-color: rgb(245, 247, 250) !important;
}
/deep/.ant-table-body .ant-table-row-hover {
  background: rgb(245, 247, 250) !important;
}
/deep/.ant-table-body .ant-table-row-hover > td {
  background: rgb(245, 247, 250) !important;
}
</style>
